import { render, staticRenderFns } from "./telRecord.vue?vue&type=template&id=54e30f06&scoped=true&"
import script from "./telRecord.vue?vue&type=script&lang=js&"
export * from "./telRecord.vue?vue&type=script&lang=js&"
import style0 from "./telRecord.vue?vue&type=style&index=0&id=54e30f06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e30f06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54e30f06')) {
      api.createRecord('54e30f06', component.options)
    } else {
      api.reload('54e30f06', component.options)
    }
    module.hot.accept("./telRecord.vue?vue&type=template&id=54e30f06&scoped=true&", function () {
      api.rerender('54e30f06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/components/telRecord.vue"
export default component.exports